import React from "react";

const GoogleIcon = () => {
  return <img src="/Google.svg" alt="google" />;
};

export default GoogleIcon;
